const AutomationStatusEnum = Object.freeze({
  NOT_AUTOMATED: 'Not Automated',
  IN_PROGRESS: 'In Progress',
  NLP_AUTOMATED: 'NLP Automated',
  EXTERNALLY_AUTOMATED: 'Externally Automated',
});
const DEFAULT_AUTOMATION_STATUS = AutomationStatusEnum.NOT_AUTOMATED;

module.exports = {
  AutomationStatusEnum,
  DEFAULT_AUTOMATION_STATUS,
}; 